import { QuestionCircleOutlined } from '@ant-design/icons'
import { Form, Tooltip } from 'antd'

import SelectPto from 'component/select/select-pto'

interface PTOSelectProps {
  disabled?: boolean
}

export const PTOSelect = ({ disabled }: PTOSelectProps) => {
  return (
    <Form.Item
      name="pto"
      rules={[{ required: true, message: 'PTO is required' }]}
      label={
        <>
          PTO
          <Tooltip
            title={
              <div className="tooltip-box">
                <p className="tooltip-text">Select the PTO for which you want to create rewards</p>
              </div>
            }
            placement="right"
          >
            <QuestionCircleOutlined className="tooltip-icon" />
          </Tooltip>
        </>
      }
    >
      <SelectPto
        disabled={disabled}
        placeholder="Select PTO"
        className="rewards-create__input"
        pageSize={100}
        filter={(pto) => !!pto.endTimeUpcoming && Date.now() < pto.endTimeUpcoming * 1000}
        sortFn={(a, b) => a.fullName.localeCompare(b.fullName)}
      />
    </Form.Item>
  )
}
